
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`2018 erlebte die Schweiz einen Hitzesommer mit starker Dürre. 2019 war es nicht ganz so trocken, dafür aber noch heisser mit Rekordtemperaturen. Und 2020 rechnen Meteorologen wieder mit einem überdurchschnittlichen Sommer. Keine guten Aussichten für den Schweizer Wald, der rund einen Drittel der Landesfläche bedeckt. Denn dieser leidet immer stärker unter den extremen Wetterbedingungen.`}</p>
    <p>{`Das stellt unter anderem der europäische `}<a parentName="p" {...{
        "href": "http://waldzustandsmonitor.de/"
      }}>{`Waldzustandsmonitor`}</a>{` fest, der von der Technischen Universität München betrieben wird. Er misst anhand von Satelliten-Aufnahmen, wie grün und damit vital die Vegetation ist. Wir haben auf Anfrage Daten für die Schweiz bekommen. Sie zeigen, dass der Stress für den Wald auch hierzulande zunimmt.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;